import React from 'react'

import AgentPropertyCard from './cards/agent-property'

const AgentProfileProperties = ({ title, type, sold, listings, marginBottom }) => {
  const [limit, setLimit] = React.useState(3)

  const items = type === 'current' ? listings : sold

  return (
    <section className={`agent-properties${marginBottom ? ' agent-properties--margin-bottom' : ''}`}>
      <div className='agent-properties__inner'>
        <h3 className='agent-properties__title'>{title}</h3>
        <div className='agent-properties__items'>
          {items?.length > 0 &&
            <>
              {items.slice(0, limit).map((el, i) => (
                <AgentPropertyCard {...el} postType='property' key={i} />
              ))}
            </>
          }
        </div>
        {limit < items?.length &&
          <button className='agent-properties__more' onClick={() => setLimit(limit + 3)}>View More Properties</button>
        }
      </div>
    </section>
  )
}

AgentProfileProperties.defaultProps = {
  title: 'Current listings',
  type: 'current',
  sold: { nodes: [] },
  listings: { nodes: [] }
}

export default AgentProfileProperties